import { render, staticRenderFns } from "./SwitchComplete.vue?vue&type=template&id=0205788c&scoped=true"
import script from "./SwitchComplete.vue?vue&type=script&lang=js"
export * from "./SwitchComplete.vue?vue&type=script&lang=js"
import style0 from "./SwitchComplete.vue?vue&type=style&index=0&id=0205788c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_17bc9983cdb7459b16429e97d92f86dc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205788c",
  null
  
)

export default component.exports